import { createSlice } from "@reduxjs/toolkit";
import GnlParametreDTO from "src/models/GnlParametre/GnlparametreDTO";
import VwSonucIzlemeTanimDTO from "src/models/Settings/Generals/VwSonucIzlemeTanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { IParametersKeyValue } from "../Base/ParametersSlice";


interface ISonucIzlemeTanim {
    open: boolean;
    testGrubu: IParametersKeyValue,
    activeRow: VwSonucIzlemeTanimDTO;
    durumActiveRow: GnlParametreDTO;
    grupActiveRow : GnlParametreDTO;
    data: VwSonucIzlemeTanimDTO[]
    edit : boolean;
}

export const SonucIzlemeTanimSlice = createSlice<ISonucIzlemeTanim , MapReducerPayloads<ISonucIzlemeTanim, {
    setOpen: boolean;
    setTestGrubu:IParametersKeyValue
    setActiveRow: VwSonucIzlemeTanimDTO
    setDurumActiveRow: GnlParametreDTO
    setGrupActiveRow: GnlParametreDTO
    setData: VwSonucIzlemeTanimDTO[]
    setEdit: boolean;
    
}>>({
    name: "SonucIzlemeTanim",
    initialState: {
        open: false,
        testGrubu: {},
        activeRow: new VwSonucIzlemeTanimDTO(),
        durumActiveRow: new GnlParametreDTO(),
        grupActiveRow: new GnlParametreDTO(),
        data: [],
        edit:false
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setTestGrubu: (state, action) => {
            state.testGrubu = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
         setDurumActiveRow: (state, action) => {
            state.durumActiveRow = action.payload;
        },
          setGrupActiveRow: (state, action) => {
            state.grupActiveRow = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
          setEdit: (state, action) => {
            state.edit = action.payload;
        }
    }

});